import { useSelector } from 'react-redux'
import { useResponsive } from 'hooks/useResponsive'
import { dispatch } from 'store'
import { editorThunks } from 'store/features/editor/thunks'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { SUB_SIDEBAR_KEYS } from 'consts/sidebar'
import { useIsTabActive } from 'hooks/useIsTabActive'
import { sidebarItems } from './consts'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'
import { aiAvatarSelectors } from 'store/features/aiAvatar/selectors'
import { aiAvatarThunks } from 'store/features/aiAvatar/thunks'

const useSidebarData = () => {
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)
  const isTabActive = useIsTabActive()
  const targetMediaItemId = useSelector(aiVideoSelectors.targetMediaItemId)
  const avatarTargetMediaItemId = useSelector(
    aiAvatarSelectors.targetMediaItemId
  )

  const setActiveTab = (tabKey: string) => {
    dispatch(editorThunks.setActiveSidebarTab(tabKey))
    dispatch(editorThunks.setAsideOverlayContent(null))

    if (isMobile) {
      dispatch(editorThunks.setIsMobileSubSidebarOpen(true))
      dispatch(editorThunks.setIsMobileInnerSliderOpen(false))
    }
  }

  const onItemClick = (tabKey: string, customAction?: () => void) => {
    if (isTabActive(tabKey)) {
      if (tabKey === SUB_SIDEBAR_KEYS.AI_VIDEO) {
        dispatch(aiVideoThunks.clearGenerationParams())
        if (targetMediaItemId) {
          dispatch(editorThunks.deselectAllTimelineItems())
        }
      }
      if (tabKey === SUB_SIDEBAR_KEYS.AI_AVATAR) {
        dispatch(aiAvatarThunks.resetGenerationParams())
        if (avatarTargetMediaItemId) {
          dispatch(editorThunks.deselectAllTimelineItems())
        }
      }
      return
    }

    setActiveTab(tabKey)
    customAction?.()
  }

  return sidebarItems.map(
    ({ key, icon, label, customAction, tabTestId, isNewLabel }) => ({
      key,
      icon,
      label,
      isActive: isTabActive(key),
      onClick: () => onItemClick(key, customAction),
      tabTestId,
      isNewLabel
    })
  )
}

export default useSidebarData
